import { Component, ElementRef, Injector, Input, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { MatAutocomplete, MatAutocompleteTrigger, MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { Router } from "@angular/router";
import { BaseComponent } from "src/app/common/base/base.component";
import { FormStatusEnum, ResourceType, AffectedSystemType, FormType, OlogNotificationType } from "src/app/common/enumerations/enumerations";
import { CancelDialogComponent } from "src/app/controls/cancel-dialog/cancel-dialog.component";
import { RelatedDocument } from "src/app/services/documents/documents";
import { FormRestriction } from "src/app/services/forms/form-restriction";
import { RelatedLinkBase } from "src/app/components/catalogs/navigation-links/link/related-link-base";
import { OLogService } from "src/app/components/olog/olog.service";
import { Resource } from "src/app/components/catalogs/beamline-catalog/resource/resources";
import { ResourcesService } from "src/app/components/catalogs/beamline-catalog/resource/resources.service";
import { RestrictionService } from "src/app/controls/restrictions/services/restriction.service";
import { PrivilegeEnum } from "src/app/common/enumerations/privilege-enum";
import { User } from "src/app/components/catalogs/user-catalog/services/user";
import { WfTaskLocalResource, WfTaskResource, WFConfiguration, WfSignatureResource, WFTaskSignatureResource } from 'src/app/components/workflow/workflow';
import { WorkFlowService } from "src/app/components/workflow/workflow.service";
import { WorkPerformer, WorkPerformerGroup } from "src/app/services/work-performer/work-performer";
import { RSSWAResource, AffectedSystem, SaveRSSWAResource, } from "../../rsswa";
import { RSSWAAcceleratorLocation, SaveRSSWAAcceleratorLocation } from "../../rsswa-accelerator-location";
import { RSSWAOtherSystem } from "../../../../controls/other-system-chips/other-system";
import { RSSWAPerformingWorkUser } from "../../rsswa-performing-work-user";
import { RSSWAShutter, SaveRSSWAShutter } from "../../rsswa-shutter";
import { RestrictionAvailableAutocompleteComponent } from "src/app/controls/restrictions/restriction-available-autocomplete/restriction-available-autocomplete.component";
import { FormRestrictionTableComponent } from "src/app/controls/restrictions/form-restriction-table/form-restriction-table.component";
import { firstValueFrom, Observable, Subscription, takeUntil } from "rxjs";
import { MessagePlaceholder } from "src/app/common/models/placeholder";
import moment from "moment";
import { utils } from "src/app/modules/libs/utils";
import { MessageTypeEnum } from "src/app/components/messages/services/message-banner.enums";
import { RsswaService } from "../../rsswa.service";
import { PartialOlogComponent } from "src/app/components/olog/partial-olog/partial-olog.component";
import { FormViewState } from "src/app/common/models/form-view-state";
import { YesNoDialogComponent } from "src/app/controls/yes-no-dialog/yes-no-dialog.component";

interface PendingAmendmentState {
  formValues: Record<string, any>;
  tmpDescription?: string;
  tmpDate?: Date;
  tmpSysAffectedBL?: boolean;
  tmpSysAffectedAcc?: boolean;
  tmpSysAffectedTombis?: boolean;
  tmpChkRepair?: boolean;
  tmpOtherSystems?: boolean;
  tmpRsswaShutters?: RSSWAShutter[];
  tmpRsswaAcceleratorLocations?: RSSWAAcceleratorLocation[];
  tmpRsswaOtherSystems?: RSSWAOtherSystem[];
  tmpRsswaRestrictions?: FormRestriction[];
  tmpRsswaRelatedLinks?: RelatedLinkBase[];
  workPerformers?: WorkPerformer[];
  documents: RelatedDocument[];
  affectedSystems?: AffectedSystem[];
}

@Component({
  selector: 'rsswa-section1',
  templateUrl: './rsswa-section1.component.html',
  styleUrls: ['./rsswa-section1.component.scss']
})

export class RsswaSection1Component extends BaseComponent implements OnInit, OnDestroy {
  @Input() rsswa?: RSSWAResource | null;
  @Input() status?: FormViewState;

  saveButtonText?: string;

  showSubmit?: boolean = false;

  disabled = true;

  // #Form Controls
  requesterCtrl = new FormControl();
  documentCtrl = new FormControl();
  estInitCtrl = new FormControl();
  estEndCtrl = new FormControl();
  performerCtrl = new FormControl();
  chkTopOffCtrl = new FormControl();
  chkRadMonitorCtrl = new FormControl();
  chkBeamlineCtrl = new FormControl();
  chkAcceleratorCtrl = new FormControl();
  chkETIAccessCtrl = new FormControl();
  chkTPLSetCtrl = new FormControl();
  chkTSoftwareCtrl = new FormControl();
  chkTopOffInterlockCtrl = new FormControl();
  chkRSSPLCSetCtrl = new FormControl();
  chkRSSSoftwareCtrl = new FormControl();

  descriptionCtrl = new FormControl();
  rsswaShuttersControl = new FormControl();
  rsswaAcceleratorLocationsControl = new FormControl();
  rsswaOtherSystemsControl = new FormControl();
  restrictionsControl = new FormControl();

  chkFuncTestCtrl = new FormControl();
  functionalTestCtrl = new FormControl();
  provisionalTestingRequiredCtrl = new FormControl();

  //#region Fields

  tmpDate?: Date;
  tmpSysAffectedBL? = false;
  tmpSysAffectedAcc? = false;
  tmpSysAffectedTombis? = false;
  tmpChkRepair? = false;
  tmpDescription?: string;
  tmpOtherSystems? = false;
  tmpRsswaShutters?: RSSWAShutter[] = [];
  tmpRsswaAcceleratorLocations?: RSSWAAcceleratorLocation[] = [];
  tmpRsswaOtherSystems?: RSSWAOtherSystem[] = [];
  tmpRsswaRestrictions?: FormRestriction[] = [];


  tmpRsswaRelatedLinks?: RelatedLinkBase[] = [];
  //
  tmpWfTableId?: number | null = null;

  workFlow?: WfTaskLocalResource[];
  workFlowPending?: WfTaskResource[];

  wfConfiguration?: WFConfiguration;
  wfSignatures?: WfSignatureResource[];
  wfTaskSignature: WFTaskSignatureResource = new WFTaskSignatureResource();
  // #Tables

  affectedSystems?: AffectedSystem[];

  requesters: User[] = [];

  allWorkPerformers?: WorkPerformer[];
  filteredWorkPerformers?: WorkPerformer[];
  filteredPerformerGroups?: WorkPerformerGroup[];
  workPerformers?: WorkPerformer[];

  rsswaPrivilege?: boolean | null = false;

  showCancelForm = false;
  showCancelNew = false;
  cancelSignature?: WfSignatureResource;
  showUnSubmit = false;
  unSubmitSignature?: WfSignatureResource;

  systemsAffectedError = false;

  sr02areasrrf?: Resource;
  topOff!: Resource;
  accelerators: Resource[] = [];

  // #Mat Chip Variables
  selectable = true;
  removable = true;
  addOnBlur = true;
  tmpResourceIds!: number[];

  @ViewChild('performerInput') performerInput?: ElementRef<HTMLInputElement>;

  @ViewChild('autoDoc') matAutocompleteDoc?: MatAutocomplete;
  @ViewChild('autoPer') matAutocompletePer?: MatAutocomplete;

  @ViewChild(MatAutocompleteTrigger) documentInput?: MatAutocompleteTrigger;
  @ViewChild(MatAutocompleteTrigger) requesterInput?: MatAutocompleteTrigger;
  @ViewChild(RestrictionAvailableAutocompleteComponent) restrictionAvailableAutocomplete?: RestrictionAvailableAutocompleteComponent;
  @ViewChild(FormRestrictionTableComponent) formRestrictionTable?: FormRestrictionTableComponent;
  newDoc?: RelatedDocument;

  popclass = 'pop-description-hidden';

  newPer?: WorkPerformer;

  /////
  rsswas?: RSSWAResource[];
  rsswasFiltered?: RSSWAResource[];
  rsswas$!: Observable<RSSWAResource[]>;
  rsswasSubs!: Subscription;

  resources?: Resource[];
  resourcesFiltered?: Resource[];
  resources$!: Observable<Resource[]>;
  resourcesSubs!: Subscription;

  workPerformersFiltered?: WorkPerformer[];
  workPerformersSubs!: Subscription;

  documents: RelatedDocument[] = [];

  signToUnsubmitAmendment: any;
  private pendingAmendmentState?: PendingAmendmentState;

  constructor(
    public service: RsswaService,
    public router: Router,
    public _wf: WorkFlowService,
    public _restriction: RestrictionService,
    public _resource: ResourcesService,
    public ologService: OLogService,
    protected override injector: Injector
  ) {
    super(injector);
  }

  //#region INIT

  ngOnInit() {
    this.rsswaPrivilege = this.hasPrivilege(PrivilegeEnum.RSSWA);
    this.loadResources();
    this.buildForm();
    this.loadUsers();

    this.loadAllWorkPerformers();
  }

  loadRequesters() {
    this.requesters = this.getActiveUsers().filter(u => this.hasPrivilegeByUser(PrivilegeEnum.Requester, u.id!));
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildForm();
    if (!this.status?.isLogView)
      this.loadRSSWAs();
    else if (this.rsswa) this.refresh(this.rsswa);
    this.loadRequesters();

  }

  loadRSSWAs() {
    this.rsswas$ = this.store.select(state => state.RSSWA.data);
    this.rsswasSubs = this.rsswas$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data?.length) {
        this.rsswas = data;
        if (this.rsswa?.id) {
          const rsswa = this.rsswas.find(r => r.id == this.rsswa?.id);
          if (rsswa) {
            this.rsswa = rsswa;
          } else {
            this.rsswa = null;
          };
        }
        this.refresh(this.rsswa);
      }
    });
  }

  loadResources() {
    this.resources$ = this.store.select(state => state.Resources.data);
    this.resourcesSubs = this.resources$.subscribe(data => {
      if (data?.length) {
        this.resources = data;
        this.accelerators = this.resources.filter(r => r.type == ResourceType.Accelerator);
        this.sr02areasrrf = this.resources.find(r => r.code == 'SR10Area(BTS)');
        const topOff = this.resources.find(r => r.code == 'TopOff');
        if (topOff)
          this.topOff = topOff;
        this.fillResources();
      }
    });
  }

  buildForm() {
    this.formGroup = new FormGroup({
      requesterCtrl: this.requesterCtrl,
      documentCtrl: this.documentCtrl,
      estInitCtrl: this.estInitCtrl,
      estEndCtrl: this.estEndCtrl,
      performerCtrl: this.performerCtrl,
      chkTopOffCtrl: this.chkTopOffCtrl,
      chkRadMonitorCtrl: this.chkRadMonitorCtrl,
      chkBeamlineCtrl: this.chkBeamlineCtrl,
      chkAcceleratorCtrl: this.chkAcceleratorCtrl,
      chkETIAccessCtrl: this.chkETIAccessCtrl,
      chkTPLSetCtrl: this.chkTPLSetCtrl,
      chkTSoftwareCtrl: this.chkTSoftwareCtrl,
      chkTopOffInterlockCtrl: this.chkTopOffInterlockCtrl,
      chkRSSPLCSetCtrl: this.chkRSSPLCSetCtrl,
      chkRSSSoftwareCtrl: this.chkRSSSoftwareCtrl,
      descriptionCtrl: this.descriptionCtrl,
      chkFuncTestCtrl: this.chkFuncTestCtrl,
      restrictionsControl: this.restrictionsControl,
      rsswaOtherSystemsControl: this.rsswaOtherSystemsControl,
      rsswaShuttersControl: this.rsswaShuttersControl,
      rsswaAcceleratorLocationsControl: this.rsswaAcceleratorLocationsControl,
      functionalTestCtrl: this.functionalTestCtrl,
      provisionalTestingRequiredCtrl: this.provisionalTestingRequiredCtrl
    });
    this.formGroup.markAsPristine();
    this.checkEnableControls();
    this.systemDesign();
    this.systemsAffectedError = false;
  }

  /**
   * Marks the form dirty and keeps unsaved amendment controls in the shared RSSWA model.
   * @param val Whether the form should be marked dirty.
   */
  override setFormDirty(val: boolean = true): void {
    if (val)
      this.syncPendingAmendmentValues();
    super.setFormDirty(val);
  }

  /**
   * Copies temporary Section 1 values into the pending amendment so toggle reloads retain them.
   */
  private syncPendingAmendmentValues(): void {
    if (!this.status?.isViewingAmendment || !this.rsswa?.rsswaAmendment)
      return;

    // Match SCF by updating the shared in-memory amendment whenever an edit becomes dirty.
    const amendment = this.rsswa.rsswaAmendment;
    amendment.description = this.tmpDescription;
    amendment.requesterId = this.requesterCtrl.value?.id;
    amendment.startOn = this.estInitCtrl.value;
    amendment.completeOn = this.estEndCtrl.value;
    amendment.beamlineRSS = this.tmpSysAffectedBL ?? false;
    amendment.acceleratorRSS = this.tmpSysAffectedAcc ?? false;
    amendment.tombis = this.tmpSysAffectedTombis;
    amendment.etiAccess = this.chkETIAccessCtrl.value;
    amendment.tombisplcSet = this.chkTPLSetCtrl.value;
    amendment.tombisSoftware = this.chkTSoftwareCtrl.value;
    amendment.repairRequired = this.tmpChkRepair;
    amendment.rssplcSet = this.chkRSSPLCSetCtrl.value;
    amendment.rssSoftware = this.chkRSSSoftwareCtrl.value;
    amendment.topOffInterlockSetPoint = this.chkTopOffInterlockCtrl.value;
    amendment.workPerformers = this.workPerformers;
    amendment.relatedDocuments = this.documents;
    amendment.topOff = this.chkTopOffCtrl.value;
    amendment.radiationMonitoringSystem = this.chkRadMonitorCtrl.value;
    amendment.beamLine = this.chkBeamlineCtrl.value;
    amendment.accelerator = this.chkAcceleratorCtrl.value;
    amendment.rsswaShutters = this.tmpRsswaShutters ?? [];
    amendment.rsswaAcceleratorLocations = this.tmpRsswaAcceleratorLocations ?? [];
    amendment.rsswaOtherSystems = this.tmpRsswaOtherSystems ?? [];
    amendment.rsswaRestrictions = this.tmpRsswaRestrictions ?? [];
    amendment.functionalTest = this.chkFuncTestCtrl.value;
    amendment.provisionalTestingRequired = this.provisionalTestingRequiredCtrl.value;
    amendment.rsswaRelatedLinks = this.tmpRsswaRelatedLinks ?? [];
  }

  /**
   * Captures unsaved amendment controls and temporary collections before another view is rendered.
   */
  preservePendingAmendmentChanges(): void {
    // Clone mutable collections so loading the current view cannot overwrite the pending amendment snapshot.
    this.pendingAmendmentState = utils.cloneDeep({
      formValues: this.formGroup.getRawValue(),
      tmpDescription: this.tmpDescription,
      tmpDate: this.tmpDate,
      tmpSysAffectedBL: this.tmpSysAffectedBL,
      tmpSysAffectedAcc: this.tmpSysAffectedAcc,
      tmpSysAffectedTombis: this.tmpSysAffectedTombis,
      tmpChkRepair: this.tmpChkRepair,
      tmpOtherSystems: this.tmpOtherSystems,
      tmpRsswaShutters: this.tmpRsswaShutters,
      tmpRsswaAcceleratorLocations: this.tmpRsswaAcceleratorLocations,
      tmpRsswaOtherSystems: this.tmpRsswaOtherSystems,
      tmpRsswaRestrictions: this.tmpRsswaRestrictions,
      tmpRsswaRelatedLinks: this.tmpRsswaRelatedLinks,
      workPerformers: this.workPerformers,
      documents: this.documents,
      affectedSystems: this.affectedSystems
    });
  }

  /**
   * Restores the editor's unsaved amendment snapshot after the amendment view is rendered.
   */
  private restorePendingAmendmentChanges(): void {
    if (!this.pendingAmendmentState)
      return;

    const pendingState = utils.cloneDeep(this.pendingAmendmentState);
    this.tmpDescription = pendingState.tmpDescription;
    this.tmpDate = pendingState.tmpDate;
    this.tmpSysAffectedBL = pendingState.tmpSysAffectedBL;
    this.tmpSysAffectedAcc = pendingState.tmpSysAffectedAcc;
    this.tmpSysAffectedTombis = pendingState.tmpSysAffectedTombis;
    this.tmpChkRepair = pendingState.tmpChkRepair;
    this.tmpOtherSystems = pendingState.tmpOtherSystems;
    this.tmpRsswaShutters = pendingState.tmpRsswaShutters;
    this.tmpRsswaAcceleratorLocations = pendingState.tmpRsswaAcceleratorLocations;
    this.tmpRsswaOtherSystems = pendingState.tmpRsswaOtherSystems;
    this.tmpRsswaRestrictions = pendingState.tmpRsswaRestrictions;
    this.tmpRsswaRelatedLinks = pendingState.tmpRsswaRelatedLinks;
    this.workPerformers = pendingState.workPerformers;
    this.documents = pendingState.documents;
    this.affectedSystems = pendingState.affectedSystems;
    this.formGroup.patchValue(pendingState.formValues, { emitEvent: false });
    this.systemDesign();
    this.setFormDirty();
    this.pendingAmendmentState = undefined;
  }

  checkEnableControls() {
    this.disabled = true;
    this.formGroup.disable();
    this.estInitCtrl?.disable();
    this.performerCtrl.disable();
    let enable: boolean | null = false;
    if (!this.status?.isViewingAmendment)
      enable = this.rsswa?.editingById == this.currentUser?.id && this.hasPrivilege(this.privilegeEnum.RSSWA) && (this.rsswa?.status == this.formStatusEnum.New || this.rsswa?.status == this.formStatusEnum.Draft);
    else
      enable = this.rsswa?.editingById == this.currentUser?.id && this.hasPrivilege(this.privilegeEnum.RSSWA) && (this.rsswa?.status == this.formStatusEnum.AmendmentDrafting && this.hasPrivilege(this.privilegeEnum.EditRSSWAAmendment));

    if (enable && !this.status?.isLogView) {
      this.disabled = false;
      this.formGroup.enable();
      this.estInitCtrl?.enable();
      this.performerCtrl.enable();
    }
  }

  clear() {
    this.rsswa = null;
    this.setFormDirty(false);

    this.formGroup?.reset();
    if (!this.currentUser) {
      'user_not_logged'
        ;
      return;
    }
    this.tmpDate = new Date();

    this.workPerformers = [];
    this.documents = [];
    this.requesters = [];
    this.affectedSystems = [];
    this.tmpRsswaShutters = [];
    this.tmpRsswaAcceleratorLocations = [];
    this.tmpRsswaOtherSystems = [];
    this.tmpRsswaRestrictions = [];
    this.tmpRsswaRelatedLinks = [];
    // this.tmpRsswaPerformingWorkUser = [];
    this.restrictionAvailableAutocomplete?.reset();
    this.estInitCtrl.setValue(null);
    this.estEndCtrl.setValue(null);

    this.chkTopOffCtrl.setValue(false);
    this.chkRadMonitorCtrl.setValue(false);
    this.chkBeamlineCtrl.setValue(false);
    this.chkAcceleratorCtrl.setValue(false);
    this.tmpOtherSystems = false;
    this.tmpSysAffectedAcc = false;
    this.tmpSysAffectedBL = false;
    this.tmpSysAffectedTombis = false;
    this.chkFuncTestCtrl.setValue(false);
    this.requesterCtrl.setValue(null);

    this.chkETIAccessCtrl.setValue(false);
    this.tmpChkRepair = false;
    this.chkRSSPLCSetCtrl.setValue(false);
    this.chkRSSSoftwareCtrl.setValue(false);
    this.chkTPLSetCtrl.setValue(false);
    this.chkTSoftwareCtrl.setValue(false);
    this.chkTopOffInterlockCtrl.setValue(false);
    this.tmpDescription = '';

    $('#chkRSSPLCSetCtrl').addClass('check-disabled');
    $('#chkRSSSoftwareCtrl').addClass('check-disabled');
    $('#chkETIAccessCtrl').addClass('check-disabled');
    $('#chkTPLSetCtrl').addClass('check-disabled');
    $('#chkTSoftwareCtrl').addClass('check-disabled');
    $('#chkTopOffInterlockCtrl').addClass('check-disabled');

    this.buildForm();

    this.chkETIAccessCtrl.disable();
    this.chkTPLSetCtrl.disable();
    this.chkTSoftwareCtrl.disable();
    this.chkTopOffInterlockCtrl.disable();
    this.chkRSSPLCSetCtrl.disable();
    this.chkRSSSoftwareCtrl.disable();
    this.showSubmit = false;

    this.systemsAffectedError = false;

    this.checkEnableControls();
    this.setButtonLabels();

    this.showCancelForm = false;
    this.showCancelNew = false;
  }

  setButtonLabels() {
    this.saveButtonText = this.rsswa?.status == FormStatusEnum.New ? 'Save as Draft' : (this.status?.isViewingAmendment ? 'Update Amendment' : 'Update Draft');
  }

  //#endregion

  //#region CREATE
  create() {
    this.clear();
    this.disabled = false;
    this.formGroup.enable();
    this.requesterCtrl.enable();

    setTimeout(() => {
      this.requesterInput?.openPanel();
    }, 1500);

  }

  addEvent() {
    if (moment(this.estEndCtrl.value).isBefore(this.estInitCtrl.value)) {
      this.estEndCtrl.setValue(this.estInitCtrl.value);
    }
    this.setFormDirty();
  }
  //#endregion

  refresh(rsswa?: RSSWAResource | null) {
    this.systemsAffectedError = false;
    if (rsswa) {
      this.rsswa = rsswa;
      if (this.rsswa?.disapprovalReason && this.rsswa?.status !== FormStatusEnum.WorkApprovals) {
        this.alert.message('HassDisapprovalReason', [new MessagePlaceholder('{DisapprovalReason}', this.rsswa.disapprovalReason)], MessageTypeEnum.Warning, 'Disaproval Warning', 5);
      }

      this.tmpDescription = this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.description : this.rsswa.description;
      this.tmpDate = this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.createdOn : this.rsswa.createdOn;
      this.setRequester(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.requesterId : this.rsswa.requesterId);
      this.documents = this.getDocuments();
      this.estInitCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.startOn : this.rsswa.startOn);
      this.estEndCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.completeOn : this.rsswa.completeOn);
      this.chkTopOffCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.topOff : this.rsswa.topOff);
      this.chkRadMonitorCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.radiationMonitoringSystem : this.rsswa.radiationMonitoringSystem);
      this.chkBeamlineCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.beamLine : this.rsswa.beamLine);
      this.chkAcceleratorCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.accelerator : this.rsswa.accelerator);
      this.tmpRsswaShutters = this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.rsswaShutters : this.rsswa.rsswaShutters;
      this.tmpRsswaAcceleratorLocations = this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.rsswaAcceleratorLocations : this.rsswa.rsswaAcceleratorLocations;
      this.tmpRsswaOtherSystems = this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.rsswaOtherSystems : this.rsswa.rsswaOtherSystems;
      this.tmpRsswaRestrictions = this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.rsswaRestrictions : this.rsswa.rsswaRestrictions;
      this.chkETIAccessCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.etiAccess : this.rsswa.etiAccess);
      this.chkTPLSetCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.tombisplcSet : this.rsswa.tombisplcSet);
      this.chkTSoftwareCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.tombisSoftware : this.rsswa.tombisSoftware);
      this.tmpChkRepair = this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.repairRequired : this.rsswa.repairRequired;
      this.chkRSSPLCSetCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.rssplcSet : this.rsswa.rssplcSet);
      this.chkRSSSoftwareCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.rssSoftware : this.rsswa.rssSoftware);
      this.chkTopOffInterlockCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.topOffInterlockSetPoint : this.rsswa.topOffInterlockSetPoint);
      this.tmpWfTableId = this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.wfTableID : this.rsswa.wfTableID;
      this.chkFuncTestCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.functionalTest : this.rsswa.functionalTest);
      this.provisionalTestingRequiredCtrl.setValue(this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.provisionalTestingRequired : this.rsswa.provisionalTestingRequired);
      this.tmpRsswaRelatedLinks = this.status?.isViewingAmendment ? this.rsswa.rsswaAmendment?.rsswaRelatedLinks : this.rsswa.rsswaRelatedLinks;

      this.workPerformers = this.getWorkPerformers();
      this.getSystemsAffected(this.rsswa.affectedSystems ?? []);
      this.fillResources();

      this.setButtonLabels();

      this.showSubmit = false;

      this.showCancelNew = this.hasPrivilege(this.privilegeEnum.RSSWACancel) && ((this.rsswa?.status == this.formStatusEnum.New && this.rsswa?.editingById == this.currentUser?.id));

      if (this.rsswa.wfTable) {
        const section = this.status?.isViewingAmendment ? 9 : 1;
        this.verifyActions(section);
      }

      this.systemDesign();
      this.buildForm();
      if (this.status?.isViewingAmendment)
        this.restorePendingAmendmentChanges();
    } else {
      this.clear();
    }
  }

  /**
    * Sets the requester based on the provided ID. If the ID corresponds to a user
    * in the `users` list and the user is not already in the `requesters` list,
    * the user is added to the `requesters` list. Additionally, updates the
    * `requesterCtrl` form control with the requester's ID.
    *
    * @param id - The ID of the requester to set. If not provided, the method does nothing.
    */
  setRequester(id?: number) {
    if (id) {
      const requester = this.users.find(u => u.id == id);
      if (requester) {
        if (!this.requesters.map(r => r.id).includes(requester.id)) {
          this.requesters.push({
            id: requester.id,
            name: requester.name,
          } as User);
        }
        this.cdRef.detectChanges();
        this.requesterCtrl?.setValue(requester);
      }
    }
    else this.requesterCtrl?.setValue(null);
  }

  /**
   * Compares two User objects to determine if they are the same based on their `id` property.
   *
   * @param a - The first User object to compare.
   * @param b - The second User object to compare.
   * @returns `true` if both User objects have the same `id`, or if both are `null` or `undefined`; otherwise, `false`.
   */
  compareRequesters = (a: User, b: User) => a?.id === b?.id;

  /**
   * Checks if a given user exists in the list of users.
   *
   * @param user - The user object to check for in the list.
   * @returns `true` if the user is found in the list, otherwise `false`.
   */
  isUserInList(user: User): boolean {
    return this.requesters.some(u => u.id === user?.id);
  }


  getSystemsAffected(as: AffectedSystem[]) {
    this.tmpSysAffectedBL = false;
    this.tmpSysAffectedAcc = false;
    this.tmpSysAffectedTombis = false;
    this.affectedSystems = as;

    as.map(a => {
      switch (a.type) {
        case AffectedSystemType.BLSystem:
          this.tmpSysAffectedBL = true;
          break;
        case AffectedSystemType.AccSystem:
          this.tmpSysAffectedAcc = true;
          break;
        case AffectedSystemType.TOMBISSystem:
          this.tmpSysAffectedTombis = true;
          break;
      }
    });

  }

  //#endregion

  //#region SAVE

  async saveForm(status: number) {
    const rsswaShutters: SaveRSSWAShutter[] = [];
    const rsswaAcceleratorLocations: SaveRSSWAAcceleratorLocation[] = [];
    const rsswaRestrictions: FormRestriction[] = [];
    const rsswaRelatedLinks: RelatedLinkBase[] = [];
    const rsswaPerformingWorkUsers: RSSWAPerformingWorkUser[] = [];

    this.tmpRsswaShutters?.map(x => {
      rsswaShutters.push({
        id: x.id,
        rsswaID: x.rsswaID,
        resourceID: x.resourceID,
      });
    });
    this.tmpRsswaAcceleratorLocations?.map(x => {
      rsswaAcceleratorLocations.push({
        id: x.id,
        rsswaID: x.rsswaID,
        resourceID: x.resourceID
      });
    });
    this.tmpRsswaRestrictions?.map(x => {
      rsswaRestrictions.push({
        id: x.id,
        formID: x.formID,
        restrictionID: x.restrictionID,
        text: x.text
      });
    });
    this.tmpRsswaRelatedLinks?.map(x => {
      rsswaRelatedLinks.push({
        id: x.id,
        formID: x.formID,
        text: x.text,
        url: x.url
      });
    });

    const rsswaResource: SaveRSSWAResource = {
      id: this.rsswa ? this.rsswa.id : 0,
      name: this.rsswa?.serialNo,
      description: this.tmpDescription,
      status: status === FormStatusEnum.WorkApprovals ? FormStatusEnum.Draft : status,
      type: FormType.RSSWA,
      code: 'RSSWA',
      serialNo: this.rsswa?.serialNo,
      requesterId: this.requesterCtrl.value?.id,
      startOn: this.estInitCtrl.value,
      completeOn: this.estEndCtrl.value,
      beamlineRSS: this.tmpSysAffectedBL,
      acceleratorRSS: this.tmpSysAffectedAcc,
      tombis: this.tmpSysAffectedTombis,
      affectedSystems: [],
      etiAccess: this.chkETIAccessCtrl.value,
      tombisPLCSet: this.chkTPLSetCtrl.value,
      tombisSoftware: this.chkTSoftwareCtrl.value,
      topOffInterlockSetPoint: this.chkTopOffInterlockCtrl.value,
      repairRequired: this.tmpChkRepair,
      rssPLCSet: this.chkRSSPLCSetCtrl.value,
      rssSoftware: this.chkRSSSoftwareCtrl.value,
      workPerformers: this.workPerformers,
      relatedDocuments: this.documents,
      topOff: this.chkTopOffCtrl.value,
      radiationMonitoringSystem: this.chkRadMonitorCtrl.value,
      beamLine: this.chkBeamlineCtrl.value,
      accelerator: this.chkAcceleratorCtrl.value,
      rsswaShutters,
      rsswaAcceleratorLocations,
      rsswaOtherSystems: this.tmpRsswaOtherSystems ?? [],
      rsswaRestrictions,
      functionalTest: this.chkFuncTestCtrl.value,
      rsswaRelatedLinks,
      rsswaPerformingWorkUsers,
      provisionalTestingRequired: this.provisionalTestingRequiredCtrl.value,
      editingById: this.currentUser?.id
    };
    // if (rsswaResource.id === 0) {
    //   if (this.isValid(status)) {
    //     //this.loading.emit(true);
    //     this.setFormDirty(false);
    //     this.service.create(rsswaResource).subscribe(data => {
    //       this.rsswa = data as RSSWAResource;
    //       this.setOpenDocument(FormType.RSSWA, this.rsswa.id);
    //       this.alert.message('DraftSaved', [new MessagePlaceholder('{serialNo}', rsswaResource.serialNo)]);
    //       //this.loading.emit(false);
    //       this.setFormDirty(false);
    //     },
    //       error => {
    //         this.alert.defaultError();
    //         console.log(error);
    //         //this.loading.emit(false);
    //       });
    //   }

    if (rsswaResource.id === 0) {
      if (this.isValid(status)) {
        this.setFormDirty(false);
        try {
          const data = await firstValueFrom(this.service.create(rsswaResource));
          this.rsswa = data as RSSWAResource;
          this.setOpenDocument(FormType.RSSWA, this.rsswa.id);
          this.alert.message('DraftSaved', [new MessagePlaceholder('{serialNo}', rsswaResource.serialNo)]);
          this.setFormDirty(false);
        } catch (error) {
          this.alert.defaultError();
          console.log(error);
        }
      }
    }

    else {
      if (this.isValid(status)) {
        //this.loading.emit(true);
        this.setFormDirty(false);
        this.service.update(rsswaResource).toPromise().then(data => {
          this.rsswa = data as RSSWAResource;
          if (status === 2) {
            if (this.wfSignatures)
              this.sign(this.wfSignatures[0].taskID, this.wfSignatures[0].approveID);
          } else {
            this.alert.message(status === 1 ? 'DraftUpdated' : 'Submitted', [new MessagePlaceholder('{serialNo}', data?.serialNo)]);
          }
          this.setOpenDocument(FormType.RSSWA, this.rsswa.id);
          this.setFormDirty(false);
        },
          error => {
            this.alert.defaultError();
            console.log(error);
            //this.loading.emit(false);
          }
        );
      } else {
        //this.loading.emit(false);
      }
    }
  }

  isValid(option: number) {
    let result = true;
    if (moment(this.estInitCtrl.value).isBefore(moment(new Date('2020/01/01')).add(-1, "day"))) {
      this.alert.message('invalidStartDate');
      this.estInitCtrl?.setErrors({ invalidDate: true });
      this.alert.message('invalidStartDate');
      result = false;
    }

    if (moment(this.estEndCtrl.value).isBefore(this.estInitCtrl.value)) {
      this.alert.message('invalidEndDate');
      this.estEndCtrl.setErrors({ invalidDate: true });
      result = false;
    }

    if (option === 2) {
      if (!this.workPerformers?.length) {
        this.alert.message('Select at least one work performer group or one work performer user');
        this.performerCtrl.setErrors({ required: true });
        result = false;
      }
      if (!this.chkTopOffCtrl.value && !this.chkRadMonitorCtrl.value && !this.chkBeamlineCtrl.value && !this.chkAcceleratorCtrl.value && !this.tmpRsswaOtherSystems?.length) {
        this.systemsAffectedError = true;
        this.alert.message('pleaseCheckOnAtLeastOneSystemAffected');
        result = false;
      }

      if (!this.requesterCtrl.value) {
        this.alert.message('invalidRequester');
        this.requesterCtrl.setErrors({ required: true });
        result = false;
      }

      if (!this.tmpDescription) {
        this.descriptionCtrl.setErrors({ required: true });
        this.alert.message('invalidDescription');
        result = false;
      }

      if (!this.tmpRsswaRestrictions?.length) {
        this.restrictionsControl.setErrors({ required: true });
        this.alert.message('No Standard Restrictions were added');
        result = false;
      }

      if (this.chkBeamlineCtrl.value && !this.tmpRsswaShutters?.length) {
        this.alert.message('If beamline checkbox is marked, you must add at least 1 shutter');
        this.rsswaShuttersControl.setErrors({ required: true });
        this.systemsAffectedError = true;
        result = false;
      }
      else this.rsswaShuttersControl.setErrors(null);

      if (this.chkAcceleratorCtrl.value && !this.tmpRsswaAcceleratorLocations?.length) {
        this.alert.message('If accelerator checkbox is marked, you must add at least 1 location');
        this.rsswaAcceleratorLocationsControl.setErrors({ required: true });
        this.systemsAffectedError = true;
        result = false;
      }
      else this.rsswaAcceleratorLocationsControl.setErrors(null);

      if (this.chkFuncTestCtrl.value && (this.status?.isViewingAmendment ? !this.rsswa?.rsswaAmendment?.rssFunctionalTests?.length : !this.rsswa?.rssFunctionalTests?.length)) {
        this.alert.error('If functional test checkbox is marked, you must add at least 1 rss functional test');
        this.functionalTestCtrl.setErrors({ required: true });
        result = false;
      }
      else this.functionalTestCtrl.setErrors(null);

    }
    if (!result) this.formGroup.markAllAsTouched();
    return result;
  }

  //#endregion

  //#region Requester Control
  onReqChange(code?: string) {
    if (!code?.includes("Arrow")) {
      this.requesters = this.users.filter(u => u.status == 1);
      const filter1 = this.requesters.filter(r =>
        r.name?.toLowerCase().includes(this.requesterCtrl.value.toLowerCase()));

      this.requesters = filter1;
    }
  }

  clickReq() {
    this.requesterInput?.openPanel();
  }

  selectedReq(e: any): void {
    // this.tmpRequesterName = e.option.value;
    // this.tmpRequester = this.getUsers()?.find(u => u.name == this.tmpRequesterName)?.id;
    // this.tmpRequesterName = e.value?.name;
    // this.tmpRequester = e.value?.id;
    this.setFormDirty();
  }

  onClosedReq() {
    // let found = false;
    // this.requesters.map(r => {
    //   if (r.name === this.tmpRequesterName) {
    //     found = true;
    //   }
    // });
  }


  clickDoc() {
    this.documentInput?.openPanel();
  }


  getDocuments(): RelatedDocument[] {
    let relatedDocs: RelatedDocument[] = [];

    if (this.rsswa) {
      if (!this.status?.isViewingAmendment)
        this.rsswa.relatedDocuments?.map(element => {
          relatedDocs.push(element);
        });
      else {
        this.rsswa.rsswaAmendment?.relatedDocuments?.map(element => {
          relatedDocs.push(element);
        });
      }
    }
    relatedDocs = relatedDocs.filter((item, index, self) => index === self.findIndex((t) => (t.relatedDocumentSerialNo === item.relatedDocumentSerialNo))).sort((a, b) => {
      if ((a.relatedDocumentTypeId ?? 0) < (b.relatedDocumentTypeId ?? 0)) return -1
      else if ((a.relatedDocumentTypeId ?? 0) > (b.relatedDocumentTypeId ?? 0)) return 1
      else return utils.sort(a.relatedDocumentSerialNo, b.relatedDocumentSerialNo)
    });

    return relatedDocs;
  }

  addDoc(event: MatChipInputEvent): void {
    // Add location only when MatAutocomplete is not open
    // To make sure this does not conflict with OptionSelected Event

    if (!this.matAutocompleteDoc?.isOpen) {
      const input = event.input;

      // Reset the input value
      if (input) {
        input.value = '';
      }

      this.documentCtrl.setValue(null);
    }
  }

  removeDoc(document: RelatedDocument): void {
    const index = this.documents.indexOf(document);

    if (index >= 0) {
      this.documents.splice(index, 1);
    }
    this.setFormDirty();
  }

  selectedDoc(event: MatAutocompleteSelectedEvent): void {

    if (this.documents === null) { this.documents = []; }
    const selDoc = event.option.value;

    this.newDoc = {
      originalDocumentId: this.rsswa != undefined ? this.rsswa.id : 0,
      originalDocumentTypeId: FormType.RSSWA,
      relatedDocumentId: selDoc.id,
      relatedDocumentSerialNo: selDoc.name,
      relatedDocumentTypeId: selDoc.type
    };

    if (!this.documents.includes(this.newDoc)) {
      this.documents.push(this.newDoc);
      //  this.documentInput.nativeElement.value = '';
      this.documentCtrl.setValue(null);
    }
    // this.hideDescription();
  }


  //#region Custom Work Performers component functions:

  loadAllWorkPerformers() {
    this.workPerformersSubs = this.store.select(state => state.WorkPerformers.data).subscribe(data => {
      if (data?.length) {
        this.allWorkPerformers = data;
        this.filterWorkPerformers();
      }
    });
  }

  onPerChange(code?: string) {
    if (!code?.includes("Arrow")) {
      this.filterWorkPerformers();
      const filter = this.filteredWorkPerformers?.filter(w =>
        w.name.toLowerCase().includes(this.performerCtrl.value?.toLowerCase()) ||
        w.code?.toLowerCase().includes(this.performerCtrl.value?.toLowerCase()));

      this.filteredWorkPerformers = filter;
      this.createWorkPerformerGroups();
    }
  }


  filterWorkPerformers() {
    this.filteredWorkPerformers = [];

    this.allWorkPerformers?.map(w => {
      let found = false;
      if (this.workPerformers) {
        for (const d of this.workPerformers) {
          found = d.id === w.id;
          if (found) {
            break;
          }
        }
      }
      if (!found) {
        this.filteredWorkPerformers?.push(w);
      }
    });
    this.createWorkPerformerGroups();
  }

  createWorkPerformerGroups() {
    const groups: WorkPerformer[] = this.filteredWorkPerformers?.filter(w => w.type === 1) ?? [];
    const persons: WorkPerformer[] = this.filteredWorkPerformers?.filter(w => w.type === 2) ?? [];

    const workGroupGroups: WorkPerformerGroup = { name: 'Groups', workPerformers: groups };
    const workGroupPersons: WorkPerformerGroup = { name: 'Persons', workPerformers: persons };

    this.filteredPerformerGroups = [];
    if (groups.length > 0) {
      groups.sort((a, b) => {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      });
      this.filteredPerformerGroups.push(workGroupGroups);
    }
    if (persons.length > 0) {
      persons.sort((a, b) => {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      });
      this.filteredPerformerGroups.push(workGroupPersons);
    }
  }

  getWorkPerformers(): WorkPerformer[] {
    const workPerformers: WorkPerformer[] = [];

    if (this.rsswa) {
      if (!this.status?.isViewingAmendment)
        this.rsswa.workPerformers?.map(element => {
          workPerformers.push(element);
        });
      else
        this.rsswa?.rsswaAmendment?.workPerformers?.map((element: any) => {
          workPerformers.push(element as WorkPerformer);
        });
    }
    return workPerformers;
  }

  addPer(event: MatChipInputEvent): void {
    // Add location only when MatAutocomplete is not open
    // To make sure this does not conflict with OptionSelected Event

    if (!this.matAutocompletePer?.isOpen) {
      const input = event.input;
      const value = event.value;

      // Reset the input value
      if (input) {
        input.value = '';
      }

      if (value != '') {
        const newPer: WorkPerformer = {
          id: 0,
          name: value,
          type: 1,
          rsswaId: this.rsswa?.id,
          roleId: 0,
          description: null,
          status: 1,
          code: null,
          persons: null
        };
        this.workPerformers?.push(newPer);
      }

      this.performerCtrl.setValue(null);
      this.filterWorkPerformers();
    }
  }

  removePer(wp: WorkPerformer): void {
    const index = this.workPerformers?.indexOf(wp) ?? -1;

    if (index >= 0) {
      this.workPerformers?.splice(index, 1);
    }
    this.filterWorkPerformers();
  }

  selectedPer(event: MatAutocompleteSelectedEvent): void {
    if (!this.workPerformers) { this.workPerformers = []; }
    const selPer = event.option.value;

    this.newPer = selPer;
    if (this.newPer) {
      this.newPer.id = 0;
      this.newPer.rsswaId = this.rsswa ? this.rsswa.id : 0;

      if (!this.workPerformers?.includes(this.newPer)) {
        this.workPerformers?.push(this.newPer);
        if (this.performerInput)
          this.performerInput.nativeElement.value = '';
        this.performerCtrl.setValue(null);
      }
      this.setFormDirty();
    }
  }

  //#endregion

  //#region Checkboxes

  systemDesign() {
    if (this.chkAcceleratorCtrl.value || this.chkBeamlineCtrl.value) {
      $('#chkRSSPLCSetCtrl').removeClass('check-disabled');
      $('#chkRSSSoftwareCtrl').removeClass('check-disabled');
      if (!this.disabled) {
        this.chkRSSPLCSetCtrl.enable();
        this.chkRSSSoftwareCtrl.enable();
      }
    } else {
      $('#chkRSSPLCSetCtrl').addClass('check-disabled');
      $('#chkRSSSoftwareCtrl').addClass('check-disabled');
      this.chkRSSPLCSetCtrl.disable();
      this.chkRSSSoftwareCtrl.disable();
    }

    if (this.chkTopOffCtrl.value) {
      $('#chkETIAccessCtrl').removeClass('check-disabled');
      $('#chkTPLSetCtrl').removeClass('check-disabled');
      $('#chkTSoftwareCtrl').removeClass('check-disabled');
      $('#chkTopOffInterlockCtrl').removeClass('check-disabled');
      if (!this.disabled) {
        this.chkETIAccessCtrl.enable();
        this.chkTPLSetCtrl.enable();
        this.chkTSoftwareCtrl.enable();
        this.chkTopOffInterlockCtrl.enable();
      }
    } else {
      $('#chkETIAccessCtrl').addClass('check-disabled');
      $('#chkTPLSetCtrl').addClass('check-disabled');
      $('#chkTSoftwareCtrl').addClass('check-disabled');
      $('#chkTopOffInterlockCtrl').addClass('check-disabled');
      this.chkETIAccessCtrl.disable();
      this.chkTPLSetCtrl.disable();
      this.chkTSoftwareCtrl.disable();
      this.chkTopOffInterlockCtrl.disable();
    }
  }

  systemChanged() {

    if (this.chkAcceleratorCtrl.value || this.chkBeamlineCtrl.value) {
      $('#chkRSSPLCSetCtrl').removeClass('check-disabled');
      $('#chkRSSSoftwareCtrl').removeClass('check-disabled');
      if (!this.disabled) {
        this.chkRSSPLCSetCtrl.enable();
        this.chkRSSSoftwareCtrl.enable();
      }
    } else {
      $('#chkRSSPLCSetCtrl').addClass('check-disabled');
      $('#chkRSSSoftwareCtrl').addClass('check-disabled');
      this.chkRSSPLCSetCtrl.disable();
      this.chkRSSSoftwareCtrl.disable();
      this.chkRSSPLCSetCtrl.setValue(false);
      this.chkRSSSoftwareCtrl.setValue(false);
    }

    if (this.chkTopOffCtrl.value) {
      $('#chkETIAccessCtrl').removeClass('check-disabled');
      $('#chkTPLSetCtrl').removeClass('check-disabled');
      $('#chkTSoftwareCtrl').removeClass('check-disabled');
      $('#chkTopOffInterlockCtrl').removeClass('check-disabled');
      if (!this.disabled) {
        this.chkETIAccessCtrl.enable();
        this.chkTPLSetCtrl.enable();
        this.chkTSoftwareCtrl.enable();
        this.chkTopOffInterlockCtrl.enable();
      }
    } else {
      $('#chkETIAccessCtrl').addClass('check-disabled');
      $('#chkTPLSetCtrl').addClass('check-disabled');
      $('#chkTSoftwareCtrl').addClass('check-disabled');
      $('#chkTopOffInterlockCtrl').addClass('check-disabled');
      this.chkETIAccessCtrl.disable();
      this.chkTPLSetCtrl.disable();
      this.chkTSoftwareCtrl.disable();
      this.chkTopOffInterlockCtrl.disable();
      this.chkETIAccessCtrl.setValue(false);
      this.chkTPLSetCtrl.setValue(false);
      this.chkTSoftwareCtrl.setValue(false);
      this.chkTopOffInterlockCtrl.setValue(false);
    }

    if (!this.chkBeamlineCtrl.value) {
      this.tmpRsswaShutters = [];
    }

    if (!this.chkAcceleratorCtrl.value) {
      this.tmpRsswaAcceleratorLocations = [];
    }

    this.fillResources();
    this.setFormDirty();
  }


  // cancelNew() {
  //   const serialNo = this.rsswa?.serialNo;
  //   const confirm = this.dialog.open(YesNoDialogComponent, {
  //     width: '600px',
  //     data: {
  //       message: this.getMessage('CancelFormDialogTitle')?.description
  //     },
  //   });

  //   confirm.afterClosed().subscribe(
  //     async data => {
  //       if (data && this.rsswa) {
  //         this.setFormDirty(false);
  //         await this.service.delete(this.rsswa.id).toPromise();
  //         await this.service.deleteSerialNo(serialNo ?? '').toPromise();
  //         this.alert.warning(serialNo + ' was Cancelled !');
  //         this.clear();
  //       }
  //     });
  // }

  async cancel() {
    if (this.rsswa?.status == this.formStatusEnum.New) {
      try {
        await this.saveForm(1);
      } catch (err) {
        console.log("Error saving form before canceling:", err);
        return;
      }
    }
    const confirm = this.dialog.open(CancelDialogComponent, {
      width: '600px',
      data: {
        amendment: (this.rsswa?.status === 6 || this.rsswa?.status === 7 || this.rsswa?.status === 9)
      }
    });

    confirm.afterClosed().subscribe(
      async data => {
        if (data?.accept) {
          this.wfTaskSignature.taskId = this.cancelSignature?.taskID;
          this.wfTaskSignature.actionId = this.cancelSignature?.cancelID;
          this.wfTaskSignature.reason = data.text;
          await this.changeEditing(false);
          await this._wf.sign(this.wfTaskSignature).toPromise().catch(error => this.alert.error(error));
          this.status!.isViewingAmendment = false;
          this.clear();
        }
      }
    );
  }

  async changeEditing(value: boolean) {
    if (this.rsswa?.id) {
      await this.service.setEditing(this.rsswa?.id, value).toPromise();
      if (this.rsswa?.status == this.formStatusEnum.AmendmentDrafting)
        this.status!.isViewingAmendment = value;
    }
  }

  // Workflow

  sign(taskId: number, actionId: number) {
    this.wfTaskSignature.taskId = taskId;
    this.wfTaskSignature.actionId = actionId;
    this._wf.sign(this.wfTaskSignature).toPromise().then(() => {
    }, error => {
      console.log(error);
      this.alert.defaultError();
    });
  }

  async editOlog() {
    if (this.rsswa?.id) {
      try {
        const data = await this.ologService.getOlog(FormType.RSSWA, this.rsswa.id, OlogNotificationType.Activate).toPromise();
        if (data) {
          const dialogRef = this.dialog.open(PartialOlogComponent, {
            height: "fit-content",
            width: "80%",
            data,
          });
          dialogRef.afterClosed().subscribe((isSaved) => {
            console.log("The dialog was closed");
            if (isSaved) {
              console.log(isSaved);
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  submit_amendment() {
    //this.loading.emit(true);
    const rsswaShutters: SaveRSSWAShutter[] = [];
    const rsswaAcceleratorLocations: SaveRSSWAAcceleratorLocation[] = [];
    const rsswaRestrictions: FormRestriction[] = [];
    const rsswaRelatedLinks: RelatedLinkBase[] = [];
    const rsswaPerformingWorkUsers: RSSWAPerformingWorkUser[] = [];

    if (!this.wfSignatures?.filter(x => !x.signed).length) {
      this.alert.error('You can\'t submit the amendment');
      return;
    }

    const taskID = this.wfSignatures.filter(x => !x.signed)[0].taskID;
    const actionID = this.wfSignatures.filter(x => !x.signed)[0].approveID;

    this.tmpRsswaShutters?.map(x => {
      rsswaShutters.push({
        id: x.id,
        rsswaID: x.rsswaID,
        resourceID: x.resourceID
      });
    });
    this.tmpRsswaAcceleratorLocations?.map(x => {
      rsswaAcceleratorLocations.push({
        id: x.id,
        rsswaID: x.rsswaID,
        resourceID: x.resourceID
      });
    });
    this.tmpRsswaRestrictions?.map(x => {
      rsswaRestrictions.push({
        id: x.id,
        formID: x.formID,
        restrictionID: x.restrictionID,
        text: x.text
      });
    });
    this.tmpRsswaRelatedLinks?.map(x => {
      rsswaRelatedLinks.push({
        id: x.id,
        formID: x.formID,
        text: x.text,
        url: x.url
      });
    });

    const saveRsswaSection1Resource: SaveRSSWAResource = {
      id: this.rsswa?.id,
      name: this.rsswa?.serialNo,
      description: this.tmpDescription,
      status: this.rsswa?.status,
      type: FormType.RSSWA,
      code: 'RSSWA',
      serialNo: this.rsswa?.serialNo,
      requesterId: this.requesterCtrl?.value?.id,
      startOn: this.estInitCtrl.value,
      completeOn: this.estEndCtrl.value,
      beamlineRSS: this.tmpSysAffectedBL,
      acceleratorRSS: this.tmpSysAffectedAcc,
      tombis: this.tmpSysAffectedTombis,
      affectedSystems: [],
      etiAccess: this.chkETIAccessCtrl.value,
      tombisPLCSet: this.chkTPLSetCtrl.value,
      tombisSoftware: this.chkTSoftwareCtrl.value,
      repairRequired: this.tmpChkRepair,
      rssPLCSet: this.chkRSSPLCSetCtrl.value,
      rssSoftware: this.chkRSSSoftwareCtrl.value,
      topOffInterlockSetPoint: this.chkTopOffInterlockCtrl.value,
      workPerformers: this.workPerformers,
      relatedDocuments: this.documents,
      topOff: this.chkTopOffCtrl.value,
      radiationMonitoringSystem: this.chkRadMonitorCtrl.value,
      beamLine: this.chkBeamlineCtrl.value,
      accelerator: this.chkAcceleratorCtrl.value,
      rsswaShutters,
      rsswaAcceleratorLocations,
      rsswaOtherSystems: this.tmpRsswaOtherSystems,
      rsswaRestrictions,
      functionalTest: this.chkFuncTestCtrl.value,
      provisionalTestingRequired: this.provisionalTestingRequiredCtrl.value,
      rsswaRelatedLinks,
      rsswaPerformingWorkUsers
    };
    if (this.isValid(2)) {
      this.setFormDirty(false);
      this.service.update(saveRsswaSection1Resource).toPromise().then(() => {
        this.setFormDirty(false);
        this.wfTaskSignature.taskId = taskID;
        this.wfTaskSignature.actionId = actionID;
        this._wf.sign(this.wfTaskSignature).toPromise().then(() => {
          //this.loading.emit(false);
        },
          () => {
            //this.loading.emit(false);
            this.alert.defaultError();
          });
      },
        () => {
          //this.loading.emit(false);
          this.alert.defaultError();
        });
    } else {
      //this.loading.emit(false);
    }
  }

  /**
   * Resolves the actions available to the current user for the displayed workflow section.
   * @param section Workflow section number represented by the form buttons.
   */
  verifyActions(section: number) {
    this.showCancelNew = false;
    this.showCancelForm = false;
    this.showSubmit = false;
    this.showUnSubmit = false;

    if (this.rsswa?.wfTableID) {
      this.wfSignatures = this.rsswa?.wfTable?.wfTableLocal?.wfSectionLocals.find(s => s.number == section)?.wfSignatures;
      const signatures = this.rsswa?.wfTable?.wfTableLocal?.wfSectionLocals.map(s => s.wfSignatures)?.flatMap(a => a || []);

      this.showCancelNew = this.hasPrivilege(this.privilegeEnum.RSSWACancel) &&
        ((this.rsswa.status == this.formStatusEnum.New && this.rsswa.editingById == this.currentUser?.id) || (this.rsswa.status == this.formStatusEnum.WorkApprovals && !signatures?.some(s => s.sectionNumber == 3 && s.signed)));

      // If amendment drafting or amendment pending, find the last amendment and get the cancelID from any of those signatures
      if (this.rsswa.status && (this.rsswa.status == this.formStatusEnum.AmendmentApprovals || this.rsswa.status == this.formStatusEnum.AmendmentDrafting) && signatures) {
        const maxAmendmentNumber = Math.max(...signatures.map(s => s.amendmentNumber ?? 0));
        const maxAmendmentSignatures = signatures.filter(s => s.amendmentNumber === maxAmendmentNumber && s.sectionNumber == 9);
        this.cancelSignature = maxAmendmentSignatures?.find(s => s.cancelID);
      }
      else {
        this.cancelSignature = signatures?.find(s => s.sectionNumber == section && s.cancelID);
      }

      if (this.cancelSignature && !this.showCancelNew) {
        this.showCancelForm = (this.rsswa.status == this.formStatusEnum.Draft && this.rsswa.editingById == this.currentUser?.id) || (this.hasRoles(this.cancelSignature.roles) && this.hasPrivilege(section == 1 ? this.privilegeEnum.RSSWACancel : this.privilegeEnum.RSSWACancelAmendment) && (section == 1 && (this.rsswa.status == this.formStatusEnum.WorkApprovals || this.rsswa.status == this.formStatusEnum.PendingActivation) || section == 9 && this.rsswa.status == this.formStatusEnum.AmendmentDrafting));
      } else {
        this.showCancelForm = false;
      }

      // Use the signatures already loaded for this section instead of deriving the same collection again.
      const sectionSignatures = this.wfSignatures;
      // The unsigned approve action assigned to the editor identifies the active submission task.
      const submitSignature = sectionSignatures?.find(s => !!s.approveID && !s.signed && this.utils.intersect(s.roles.map(r => r.id), this.currentUser?.userRole?.map(ur => ur.roleID)));
      this.showSubmit = !!submitSignature;

      const amendmentActive = this.rsswa.rsswaAmendment && (this.rsswa?.status == FormStatusEnum.AmendmentApprovals || this.rsswa.status == FormStatusEnum.AmendmentDrafting);

      if (!amendmentActive) {
        this.unSubmitSignature = signatures?.find(s => (s.sectionNumber == 1 || s.sectionNumber == 3) && !!s.disapproveID);
        this.showUnSubmit = submitSignature?.signedBy?.id == this.currentUser?.id && !!this.unSubmitSignature?.disapproveID && !signatures?.some(s => s.sectionNumber == 3 && s.signed);
      }
      else if (this.rsswa.status && this.rsswa.status == this.formStatusEnum.AmendmentApprovals && signatures) {
        // this.unSubmitSignature = signatures?.find(s => s.sectionNumber == 10 && s.disapproveID && !s.disabled);
        // this.showUnSubmit = submitSignature?.signedBy?.id == this.currentUser?.id && !this.unSubmitSignature?.signed;
        const maxAmendmentNumber = Math.max(...signatures.map(s => s.amendmentNumber ?? 0));
        const maxAmendmentSignatures = signatures.filter(s => s.amendmentNumber === maxAmendmentNumber && s.sectionNumber == 10);
        this.showUnSubmit = submitSignature?.signedBy?.id == this.getCurrentUser()?.id && !maxAmendmentSignatures.some(s => s.signed);
        this.unSubmitSignature = maxAmendmentSignatures?.find(s => s.disapproveID && !s.disabled);
      }
      else this.showUnSubmit = false;
    }
  }

  disapprove() {
    if (this.unSubmitSignature) {
      const unsubmitTask: WFTaskSignatureResource = {
        taskId: this.unSubmitSignature?.taskID,
        actionId: this.unSubmitSignature?.disapproveID //test
      }
      this._wf.sign(unsubmitTask).toPromise();
    }
  }

  fillResources() {
    this.tmpResourceIds = [];
    this.tmpResourceIds = this.tmpResourceIds.concat(this.tmpRsswaShutters?.map(x => x.resourceID) ?? []);
    this.tmpResourceIds = this.tmpResourceIds.concat(this.tmpRsswaAcceleratorLocations?.map(x => x.resourceID) ?? []);
    if (this.chkRadMonitorCtrl.value && this.sr02areasrrf)
      this.tmpResourceIds.push(this.sr02areasrrf.id);
    if (this.chkTopOffCtrl.value && this.topOff) {
      this.tmpResourceIds.push(this.topOff.id);
    }
    if (this.tmpRsswaOtherSystems?.length)
      this.tmpResourceIds = this.tmpResourceIds.concat(this.accelerators.map(x => x.id));
    const r = this.tmpRsswaRestrictions?.filter(x => x.restrictionID)?.map(x => x.restriction) ?? [];
    this.restrictionAvailableAutocomplete?.refresh(this.tmpResourceIds, r);

  }

  restrictionsChanged(e: FormRestriction[]) {
    this.tmpRsswaRestrictions = e;
    this.setFormDirty();
    this.fillResources();
  }

  /**
   * Returns embedded resources or ID-based placeholders that the chip control can enrich from the catalog.
   * @param relationships RSSWA shutter or accelerator-location relationships to display.
   */
  getResources(relationships: RSSWAShutter[] | RSSWAAcceleratorLocation[] | undefined): Resource[] {
    return relationships?.map(relationship => {
      if (relationship.resource)
        return relationship.resource;

      // History snapshots retain the resource ID even when the embedded catalog object was not serialized.
      const resource = new Resource();
      resource.id = relationship.resourceID;
      // Cache the placeholder so change detection does not repeatedly recreate and enrich the same resource.
      relationship.resource = resource;
      return resource;
    }) ?? [];
  }

  onRsswaShuttersEdited(e: Resource[]) {
    if (!this.tmpRsswaShutters) this.tmpRsswaShutters = [];
    e.map(r => {
      if (!this.tmpRsswaShutters?.find(s => s.resourceID == r.id))
        this.tmpRsswaShutters?.push({ id: 0, rsswaID: this.rsswa?.id, resource: r, resourceID: r.id });
    });
    this.tmpRsswaShutters?.map((s, i) => {
      if (!e.find(r => r.id == s.resourceID))
        this.tmpRsswaShutters?.splice(i, 1);
    });
    this.setFormDirty();
    this.fillResources();
  }

  onRsswaAcceleratorLocationsEdited(e: Resource[]) {
    if (!this.tmpRsswaAcceleratorLocations) this.tmpRsswaAcceleratorLocations = [];
    e.map(r => {
      if (!this.tmpRsswaAcceleratorLocations?.find(s => s.resourceID == r.id))
        this.tmpRsswaAcceleratorLocations?.push({ id: 0, rsswaID: this.rsswa?.id, resource: r, resourceID: r.id });
    });
    this.tmpRsswaAcceleratorLocations?.map((s, i) => {
      if (!e.find(r => r.id == s.resourceID))
        this.tmpRsswaAcceleratorLocations?.splice(i, 1);
    });
    this.setFormDirty();
    this.fillResources();
  }

  onRsswaOtherSystemsEdited(e: any) {
    this.tmpRsswaOtherSystems = e;
    this.setFormDirty();
    this.fillResources();
  }


  onRelatedLinksEdited(e: any) {
    this.tmpRsswaRelatedLinks = e;
    this.setFormDirty();
  }

  descriptionChanged(e: any) {
    this.tmpDescription = e;
    this.setFormDirty();
  }


  provisionalTestingRequiredChanged(text: string) {
    this.provisionalTestingRequiredCtrl.setValue(text);
    if (this.rsswa) {
      if (!this.status?.isViewingAmendment) {
        this.rsswa.provisionalTestingRequired = text;
      }
      else if (this.rsswa.rsswaAmendment)
        this.rsswa.rsswaAmendment.provisionalTestingRequired = text;
    }
    this.setFormDirty();
  }


  showAlert(e: any) {
    this.alert.error(e);
  }

  setUnsubmit() {

  }

  diffRelatedDocuments() {
    if (this.rsswa && this.status?.isViewingAmendment) {
      const r1 = this.rsswa?.relatedDocuments?.map(r => r.relatedDocumentSerialNo).sort((a, b) => utils.sort(a, b)) ?? [];
      const r2 = this.documents?.map(r => r.relatedDocumentSerialNo).sort((a, b) => utils.sort(a, b));
      return utils.JSONstringify(r1) != utils.JSONstringify(r2);
    }
    return false;
  }

  diffWorkPerformers() {
    if (this.rsswa && this.status?.isViewingAmendment) {
      const r1 = this.rsswa?.workPerformers?.map(r => r.roleId).sort((a, b) => utils.sort(a, b));
      const r2 = this.workPerformers?.map(r => r.roleId).sort((a, b) => utils.sort(a, b));
      return utils.JSONstringify(r1) != utils.JSONstringify(r2);
    }
    return false;
  }

  diffShutters() {
    if (this.rsswa && this.status?.isViewingAmendment) {
      const r1 = this.rsswa?.rsswaShutters?.map(r => r.resourceID).sort((a, b) => utils.sort(a, b));
      const r2 = this.tmpRsswaShutters?.map(r => r.resourceID).sort((a, b) => utils.sort(a, b));
      return utils.JSONstringify(r1) != utils.JSONstringify(r2);
    }
    return false;
  }

  diffAccelerators() {
    if (this.rsswa && this.status?.isViewingAmendment) {
      const r1 = this.rsswa?.rsswaAcceleratorLocations?.map(r => r.resourceID).sort((a, b) => utils.sort(a, b));
      const r2 = this.tmpRsswaAcceleratorLocations?.map(r => r.resourceID).sort((a, b) => utils.sort(a, b));
      return utils.JSONstringify(r1) != utils.JSONstringify(r2);
    }
    return false;
  }

  diffOtherSystems() {
    if (this.rsswa && this.status?.isViewingAmendment) {
      const r1 = this.rsswa?.rsswaOtherSystems?.map(r => r.text).sort((a, b) => utils.sort(a, b));
      const r2 = this.tmpRsswaOtherSystems?.map(r => r.text).sort((a, b) => utils.sort(a, b));
      return utils.JSONstringify(r1) != utils.JSONstringify(r2);
    }
    return false;
  }

  diffRelatedLinks() {
    if (this.rsswa && this.status?.isViewingAmendment) {
      const r1 = this.rsswa?.rsswaRelatedLinks?.map(r => { return { t: r.text, u: r.url }; }).sort((a, b) => utils.sort(a.t, b.t));
      const r2 = this.tmpRsswaRelatedLinks?.map(r => { return { t: r.text, u: r.url }; }).sort((a, b) => utils.sort(a.t, b.t));
      return utils.JSONstringify(r1) != utils.JSONstringify(r2);
    }
    return false;
  }

  diffRestrictions() {
    if (this.rsswa && this.status?.isViewingAmendment) {
      const r1 = this.rsswa?.rsswaRestrictions?.map(r => r.restrictionID).sort((a, b) => utils.sort(a, b));
      const r2 = this.tmpRsswaRestrictions?.map(r => r.restrictionID).sort((a, b) => utils.sort(a, b));
      this.tmpRsswaRestrictions?.map(r => {
        r.hilite = !r1?.find(s => s == r.restrictionID);
      });
      return utils.JSONstringify(r1) != utils.JSONstringify(r2);
    }
    return false;
  }

  diffDescription() {
    return this.rsswa?.description != this.tmpDescription;
  }


  getRoleCodes(user: User): string | undefined {
    return user.userRole?.map(r => r.role?.code).join('/');
  }

}
